<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">他山之石></span>
        <span @click="GoreportOutside">学习他人></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>刘涛:一体推进公安队伍“不敢腐、不能腐、不想腐”</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>
        <h3>扫黑除恶专项斗争以来，驻市公安局纪检监察组发挥“派”的权威，彰显“驻”的优势，督促全市公安机关深入开展“扫黑、除恶、打财、破伞、反腐”，扫黑除恶取得阶段性成效。同时，强化专项斗争监督执纪问责，一小部分民警因执法犯法、失职渎职、充当黑恶势力“保护伞”受到严肃查处，被及时清除公安队伍，有效维护了公安机关良好政治生态。今年是专项斗争第二年，各级公安党组织和纪检组织要按照党中央部署，将公安队伍规范化管理由治标向治本方向转化，标本兼治，一体推进“不敢腐、不能腐、不想腐”，确保公安队伍绝对忠诚、绝对纯洁、绝对可靠。,把信访举报作为纪律审查的线索的第一来源渠道，充分发挥其“预警器”和“晴雨表”作用，注重精准分析，提高办信质效，积极探索化解基层信访问题的新途径、新办法，不断推进信访举报工作高质量发展。</h3>
        <h3>
          <b>一、常态教育，让民警“不敢腐”</b>
        </h3>
        <h3>(增强不敢腐的震慑，要在预防、惩处、教育等方面一体化推进。警示教育，要在“常”“长”“新”三个方面着力。一是教育要经常。习近平总书记用“三个不能有”告诫全党：“在全面从严治党这个问题上，我们不能有差不多了，该松口气、歇歇脚的想法，不能有打好一仗就一劳永逸的想法，不能有初见成效就见好就收的想法。”警示教育，既要抓住关键节点，比如容易滋生“四风”问题的重要节日，当好婆婆嘴，逢节必提醒，也要注重“因材施教”，结合各部门、各警种、各岗位的廉政风险特点，有针对性的开展廉政教育。二是效果要悠长。惩处，是最有力的教育。违纪违法民警案例，是鲜活的教材。要用好违纪违法民警的典型案例，收集忏悔书，编写警示录，拍摄警示片，组织民警参加法院庭审旁听等，用身边事教育身边人。对问题反映集中、违纪问题严重、不知悔改的民警，通过在民警大会现场宣布留置，增强教育震慑力。三是形式要新颖。在宣传教育阵地建设上，在驻局纪检监察组网站打造警示教育基地，开辟“通报曝光”“涉警案件”“学思践悟”等警示教育专栏。在宣传内容上，既要有反面的典型，也要有正能量的廉洁从警故事。在宣传形式上，既要立足传统的纸质媒体、网络媒体，也要探索微信公众号、H5、微动画等新媒体，让民警喜闻乐见，潜移默化受教育。.11%。从村（社区）干部受处理具体案例来分析，两人或两人以上“抱团”违纪现象比较普遍。主要表现为以村支部书记、主任为核心，其他村组干部参与、共同“谋划”的利益“小团体”，成为违纪违法问题的高危群体。如，该市太平镇崔垱村、大王村从村支部书记到村委会委员，集体挪用粮食直补款、坐收坐支集体资金等，涉及村“两委”干部达5人。+体会交流+廉政党课”的方式召开了“一案一教育”警示教育大会，强化警示教育的感染力和说服力。</h3>
        <h3>
          <b>二、扎紧笼子，让民警“不能腐”</b>
        </h3>
        <h3>扎紧不能腐的笼子，筑牢不能腐的堤坝，要在公正执法、加强执法权力制约、狠抓执法监督等方面下功夫。一要织密执法监管的“铁笼子”。针对近年来暴露出的民警违纪违法问题，分门别类进行梳理，查找执法监督漏洞，制定有效措施，完善相关制度，加强权力制约，把民警的执法权关进制度的笼子。同时，加强执法公开，推行阳光执法，减少腐败土壤。二要牵住法制监督的“牛鼻子”。法制监督的主体责任，是各级法制部门、法制警长和法制员。要探索民警执法过错追究与法制部门责任追究连带机制，把民警执法权与法制执法监督权捆绑在一起，层层织密执法监督网，减少腐败滋生土壤。建立每月法制监督联席会议机制，法制部门在日常法制监督中发现的严重违纪违法问题，及时移交派驻纪检监察组按照“四种形态”进行处理，提高执法监督的权威性。三要用好外部监督的“专业队”。公安民警执法环境相对封闭，法制监督长期存在“外行不懂监督”或者“上级监督太远、同级监督太软”的问题，因此在不违反案件保密规定和影响案件正常办理情况下，探索引入法院、检察院及律师事务所等第三方监督力量，定期对公安机关已侦结案件进行“回头看”，减少工作阻力和外部干扰，发现“猫腻”，清理“顽疾”。四要发挥“再监督”的“杀手锏”。派驻纪检监察组的定位在于“监督的再监督”，对执法监督成效进行再检查。组织全市公安机关法制监督专业人才，不定期开展执法规范化抽查，从重查处一批典型执法违法、权力寻租案件，让执法民警习惯在受监督的状态下执法办案，使监督成为广大民警终身廉洁从警的“护身符”。.76%，同比增长7.25%。主要原因是由于各地各单位受理信访举报的时间不同，信访人担心信访件未被受理或重视不够，在等待的过程中重复反映问题，导致重复访数量居高不下。2019年越级访15件次，同比下降57.14%。主要原因是枣阳市纪委监委领导班子认真执行定期下访接访制度，主要领导每周四固定接访，去年共接待群众面访36批次581人次，上访对象无一人越级访，有效缓解了全市大信访压力，越级访乱象得到了遏止；二是自办案件增加，上级转交件下降。2019年共受理信访举报995件，同比基本持平。其中本级自收573件，占57.59%，同比增长57.85%；上级转交办422件，占42.41%，同比下降33.02%。主要原因是随着全面从严治党不断向纵深推进，信访干部履职尽责意识不断增强，办信办访能力增强，加之信访渠道的通畅及日益拓宽，干部主动接访、带案下访、重点约访的机制发挥了积极作用，群众在本级信访诉求能够得到有效解决，越级向上反映问题大幅减少。三是信访反映村级干部增加，乡科级干部减少。2019年信访反映村（社区）人员419件，同比增长16.06%，反映乡科级干部198件，同比下降30.5%。从中不难看出在全面从严治党的高压态势下，不敢腐的震慑已经形成，不能腐的笼子正在扎牢，不想腐的自觉逐步增强，但从村干部信访举报持续增长的趋势显示，全面从严治党“最后一米”的问题还不够彻底，违反群众纪律和廉洁纪律类问题仍然居高不下，破坏了党群干群关系，蚕食了群众切身利益。 闵翼飞）</h3>
        <h3>
          <b>三、正向激励，让民警“不想腐”</b>
        </h3>
        <h3>习近平总书记指出，干部队伍建设要坚持正向激励与反向约束相结合。近年来，市公安局党委在正向激励上开展了一定探索，但还存在一些短板，部分民警的警察荣誉感、职业归属感还不强，下一步要在五个方面共同发力，形成系统。一要坚持政治建警。善于用习近平新时代中国特色社会主义思想武装全警，从政治上建设和掌握公安机关，引导全警增强“四个意识”、坚定“四个自信”、做到“两个维护”，始终在思想上政治上行动上同党中央保持高度一致。加强思想政治工作，教育全警牢固树立正确的世界观、人生观、价值观，增强警察荣誉感、使命感、责任感。二要坚持从优待警。除了基本的工资待遇保障，应成立专门 “从优待警”部门，专人专责，整合工会、警保、政工等各部门职责，列出从优待警清单，开展团购优惠活动，让民警有更多的获得感、归属感。三要坚持文化育警。每月一个主题，开展丰富多彩的公安文化活动，育警魂、激壮志，增强民警的职业认同感。四要坚持人才兴警。大力选树扫黑除恶专项斗争中涌现出来的公安典型，注重在扫黑除恶专项斗争一线发现干部、培养干部、选拔干部，加大对扫黑除恶民警提拔重用、立功受奖的倾斜，加强政策宣传力度，让其他民警看得见、摸得着，使扫黑除恶成为公安机关最光荣的岗位，弘扬襄阳公安正能量。五要坚持以情暖警。发挥党支部教育、管理、监督党员的作用，落实好“三会一课”制度，开展经常性谈心谈话，不定期开展家庭送奖和廉政家访，掌握民警真实想法、家庭困难和八小时以外生活情况，让民警时刻感受到监督就在身边、关怀无处不在。</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/bannertest1.jpg"),
      PicBannertest2: require("../../../../assets/image/bannertest2.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    },
    GoreportOutside() {
      this.$router.push({ name: "forumOutside" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
  text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b {
  display: block;
  margin-top: 20px;
}
img {
  margin: 20px 0px;
}
.mg-16 {
  margin: 0px 16px;
}
</style>